<template>
  <div class="card-container">
    <div class="card-planos">
      <div class="card-planos-btns text-center">
        <b-button
          class="btn-planos"
          @click="pesquisarTabelaPlano(uniflexPersonal)"
        >
          {{ uniflexPersonal.nome }}
        </b-button>
        <b-button class="btn-planos" @click="pesquisarTabelaPlano(unimedLight)">
          {{ unimedLight.nome }}
        </b-button>
        <b-button
          class="btn-planos"
          @click="pesquisarTabelaPlano(unimedUfsc)"
          v-if="isShowButtonUFSC"
        >
          {{ unimedUfsc.nome }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    isShowButtonUFSC: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uniflexPersonal: {
        nome: "Uniflex e Personal",
        tabela: "UNIFLEX/PERSONAL",
      },
      unimedLight: {
        nome: "Unimed Light",
        tabela: "LIGHT",
      },
      unimedUfsc: {
        nome: "Unimed UFSC",
        tabela: "UFSC",
      },
    };
  },
  methods: {
    pesquisarTabelaPlano(plano) {
      localStorage.setItem("Plano", JSON.stringify(plano));

      let tipoPessoa = "pf";
      if (this.isShowButtonUFSC)
        tipoPessoa = "pj";  

        localStorage.setItem("TipoPessoa", JSON.stringify(tipoPessoa));

      this.$router.push({ name: "Tabelas" });
    },
  }
};
</script>

<style scoped>
.card-planos {
  padding: 50px 0;
}

.btn-planos {
  font-family: UnimedSans-Bold;
  width: 190px;
  height: 40px;
  margin: 15px 25px;
  border-radius: 6px;
  border: 1px solid #439763;
  background-color: #439763;
  opacity: 1;
}

.btn-planos:hover {
  background-color: #2d6542;
  border-color: #2d6542;
}
</style>
